<template>
  <div class="collection-item-box" @click="$modal.open('family', family)">
    <h2 class="truncate" v-text="family.name"></h2>
    <hr>
    <div class="flex">
      <vue-tag icon="cupcake-solid">{{ family.products_count || 0 }} {{ family.products_count > 1 ? 'produits' : 'produit' }}</vue-tag>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    family: {
      type: Object,
      required: true,
    },
  },
};
</script>